// src/components/JobView/Tabs/ProductDetailsDisplayTab.js

import React from 'react';

const ProductDetailsDisplayTab = ({ jobData, setMaximizedImageUrl }) => {
  return (
    <div className="space-y-8 p-4">
      {/* Sección Principal */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <p className="text-sm font-bold text-gray-600">Tipo</p>
          <p className="mt-1 text-gray-900">{jobData.type || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm font-bold text-gray-600">Producto / Clase</p>
          <p className="mt-1 text-gray-900">{jobData.product || jobData.class || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm font-bold text-gray-600">Cantidad</p>
          <p className="mt-1 text-gray-900">{jobData.quantity}</p>
        </div>
      </div>

      {/* --- NUEVA SECCIÓN DE BLOQUES (AÑADIDA) --- */}
      {jobData.hasBlocks && jobData.blocks && jobData.blocks.length > 0 && (
        <div className="border-t pt-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-4">Bloques Definidos</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {jobData.blocks.map((block, index) => (
                    <div key={index} className="bg-gray-50 p-3 rounded-md border">
                        <p className="font-semibold text-gray-800">{block.name}</p>
                        <p className="text-sm text-gray-500 font-mono">Código: {block.code}</p>
                    </div>
                ))}
            </div>
        </div>
      )}

      {/* Sección de Componentes */}
      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Componentes</h3>
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-3 py-2 text-center w-40">Preview</th>
                        <th className="px-3 py-2 text-left">Nombre</th>
                        <th className="px-3 py-2 text-left">Código</th>
                        <th className="px-3 py-2 text-center">Total Piezas</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {(jobData.components && jobData.components.length > 0) ? (
                      jobData.components.map((comp, index) => (
                        <tr key={index}>
                            <td className="px-3 py-2 align-middle text-center">
                                {comp.imageUrl ? 
                                  <img 
                                    src={comp.imageUrl} 
                                    alt={comp.name} 
                                    className="h-16 w-auto mx-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
                                    onClick={() => setMaximizedImageUrl(comp.imageUrl)}
                                  /> : 'Sin imagen'
                                }
                            </td>
                            <td className="px-3 py-2 align-middle">{comp.name}</td>
                            <td className="px-3 py-2 align-middle">{comp.code}</td>
                            <td className="px-3 py-2 font-medium align-middle text-center">
                                {parseInt(comp.qtyPerProduct || 0) * parseInt(jobData.quantity || 0)}
                            </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-10 text-gray-500">No hay componentes definidos para este trabajo.</td>
                      </tr>
                    )}
                </tbody>
            </table>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsDisplayTab;

